import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Row, Col, Button, Card, Tabs, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import TableSearch from "../../../../Components/TableSearch";

import { fetchUnRegisteredProperty, fetchRegisteredProperty, getFilterMetaData } from "../../../../actionCreators/Property";
import { useHistory } from "react-router-dom";
import Register from './Register';
import Unregister from './Unregister';
import { transformFilterMetaData } from "../../../../utils";




function PropertiesRegisteration({
    fetchUnRegisteredProperty,
    AdminUnRegisteredProperties,
    fetchRegisteredProperty,
    AdminRegisteredProperties,
    getFilterMetaData,
    filterMetaData
}) {
    const styles = {
        titleButtonParent: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        uploadButton: {
            padding: "7px 18px",
            background: "#284F68",
            color: "white",
            borderRadius: "5px",
            fontWeight: "500",
            fontSize: "15px",
            cursor: "pointer",
            marginRight: "8px",
        },
        contentWrapper: {
            marginLeft: "10px",
            marginRight: "10px",
        },
    };

    const [propertyCounter, setPropertyCounter] = React.useState('');
    const showPropertyCount = (count) => setPropertyCounter(count ? `(${count})` : '')
	

    React.useEffect(() => {
        getFilterMetaData();
    }, [])

    return (
        <React.Fragment>
            <div style={styles.titleButtonParent}>
                <div>
                    <Typography className="heading">
                        {`Properties${propertyCounter}`}
                    </Typography>
                </div>
            </div>

            <Card bordered={false}>
                <Tabs defaultActiveKey="1" destroyInactiveTabPane={true}>
                    <Tabs.TabPane tab="REGISTERED PROPERTIES" key="1">
                        {
                            [undefined, null].includes(filterMetaData?.data) ?
                                <div className="spin-loader">
                                    <Spin size="large" />
                                </div>
                                :
                                <Register
                                    fetchRegisteredProperty={fetchRegisteredProperty}
                                    AdminRegisteredProperties={AdminRegisteredProperties}
                                    filterMetaData={transformFilterMetaData(filterMetaData?.data)}
                                    loading={AdminRegisteredProperties?.loading}
                                    handlePropertyCount={x => showPropertyCount(x)}
                                />
                        }
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="UNREGISTERED PROPERTIES" key="2">
                        {
                            [undefined, null].includes(filterMetaData?.data) ?
                                <div className="spin-loader">
                                    <Spin size="large" />
                                </div>
                                :
                                <Unregister
                                    fetchUnRegisteredProperty={fetchUnRegisteredProperty}
                                    AdminUnRegisteredProperties={AdminUnRegisteredProperties}
                                    filterMetaData={transformFilterMetaData(filterMetaData?.data)}
                                    loading={AdminUnRegisteredProperties?.loading}
                                    handlePropertyCount={x => showPropertyCount(x)}
                                />
                        }
                    </Tabs.TabPane>
                </Tabs>
            </Card>
        </React.Fragment>
    )
}



const mapStateToProps = ({ user: user, property: { filterMetaData, AdminRegisteredProperties, AdminUnRegisteredProperties } }) => ({
    user,
    AdminRegisteredProperties,
    AdminUnRegisteredProperties,
    filterMetaData
});

const mapDispatchToProps = (dispatch) => ({
    fetchRegisteredProperty: bindActionCreators(fetchRegisteredProperty, dispatch),
    fetchUnRegisteredProperty: bindActionCreators(fetchUnRegisteredProperty, dispatch),
    getFilterMetaData: bindActionCreators(getFilterMetaData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesRegisteration);

